<template>
  <div v-if="visible" class="consult_overlay">
    <div class="consult_container">
      <div class="close_btn" @click="close">×</div>
      <div class="left_panel">
        <div class="title_box">
          <img class="title_icon" src="@/assets/pc/liaotian.png" alt="icon" />
          <span class="title_text">在线答疑</span>
        </div>
        <ul class="contact_list">
          <li
            v-for="(c, i) in contactsData"
            :key="i"
            :class="{ active: i === activeIndex }"
            @click="handleContactClick(i, c)"
          >
            <span v-if="c.has_unread == 1" class="unread_dot"></span>
            <img class="avatar" v-if="c.user_image" :src="c.user_image" alt="" />
            <img v-else class="avatar" src="@/assets/per.png" alt="">
            <div class="name">{{ c.user_name }}</div>
          </li>
        </ul>
      </div>
      <div class="right_panel">
        <div v-if="showPlaceholder" class="placeholder_panel">
          <img class="placeholder_img" src="@/assets/pc/zxdybg.png" alt="placeholder" />
        </div>
        <template v-else>
          <div class="chat_header">
            <div class="header_user">
              <div class="name">{{ currentContact.user_name || currentContact.name || "会话名称" }}</div>
              <img class="avatar" v-if="currentContact.user_image" :src="currentContact.user_image" alt="" />
              <img v-else class="avatar" src="@/assets/per.png" alt="" />
            </div>
          </div>
          <div class="chat_body" ref="chatBody">
            <div v-if="messagesLoading" class="chat_hint">加载中...</div>
            <div v-else-if="!messagesData.length" class="chat_hint">暂无消息</div>
            <div
              v-for="(m, idx) in messagesData"
              :key="idx"
              :class="['msg', m.side]"
            >
              <div class="bubble" :class="m.side">
                <img
                  v-if="String(m.message_type) === '2' && m.file_url"
                  class="msg_image"
                  :src="m.file_url"
                  alt=""
                />
                <video
                  v-else-if="String(m.message_type) === '3' && m.file_url"
                  class="msg_video"
                  :src="m.file_url"
                  controls
                  preload="metadata"
                ></video>
                <span v-else>{{ m.text }}</span>
              </div>
            </div>
          </div>
          <div class="chat_footer">
            <div class="tools">
              <span class="tool_btn" :class="{ disabled: sending }" @click="triggerImageSelect">图片</span>
              <span class="tool_btn" :class="{ disabled: sending }" @click="triggerVideoSelect">视频</span>
              <input
                ref="imageInput"
                class="file_input"
                type="file"
                accept="image/*"
                @change="handleImageSelected"
              />
              <input
                ref="videoInput"
                class="file_input"
                type="file"
                accept="video/*"
                @change="handleVideoSelected"
              />
            </div>
            <div class="input_row">
              <input
                v-model="inputText"
                class="text_input"
                type="text"
                placeholder="请在此输入内容..."
                @keyup.enter="send"
              />
              <button class="send_btn" :disabled="sending" @click="send">发送</button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { put } from "@/utils/Oss";

export default {
  name: "ConsultDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    presetUserId: {
      type: [String, Number],
      default: null,
    },
    presetUserType: {
      type: [String, Number],
      default: null,
    },
    contacts: {
      type: Array,
      default: () => [],
    },
    messages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeIndex: -1,
      showPlaceholder: true,
      inputText: "",
      contactsLoading: false,
      contactsData: [],
      messagesLoading: false,
      sending: false,
      innerMessages: [],
      messagesCache: {},
      pollTimer: null,
      polling: false,
      lastMessageIdByConversation: {},
      seenMessageIdsByConversation: {},
      defaultContacts: Array.from({ length: 10 }).map(() => ({
        name: "这里是名字",
      })),
      defaultMessages: [
        { side: "left", text: "请问您有什么问题要问我？" },
        { side: "right", text: "这是问题一：一段文字，请您帮我解读一下" },
        { side: "left", text: "好的，请稍等，马上为您解答，请你耐心等待……" },
        {
          side: "right",
          text: "这是一段文字这是一段文字这是一段文字这是一段文字这是一段文字这是一段文字这是一段文字……",
        },
      ],
    };
  },
  computed: {
    messagesData() {
      return this.messages && this.messages.length
        ? this.messages
        : this.innerMessages;
    },
    currentContact() {
      return this.contactsData[this.activeIndex] || { name: "会话名称" };
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.showPlaceholder = true;
        this.activeIndex = -1;
        this.fetchConversationList().then(() => {
          this.trySelectPresetConversation();
        });
        this.startPolling();
      } else {
        this.stopPolling();
      }
    },
    presetUserId() {
      if (!this.visible) return;
      this.trySelectPresetConversation();
    },
    presetUserType() {
      if (!this.visible) return;
      this.trySelectPresetConversation();
    },
  },
  methods: {
    close() {
      this.stopPolling();
      this.$emit("update:visible", false);
    },
    fetchConversationList() {
      if (!this.visible) return;
      if (this.contacts && this.contacts.length) return Promise.resolve();
      if (this.contactsLoading) return Promise.resolve();
      this.contactsLoading = true;
      return this.$axios
        .post(`/v1/chat/conversationList`, {}, { useLog: true })
        .then((res) => {
          if (res.code == 0) {
            this.contactsData = res.data.list;
            this.activeIndex = -1;
            this.innerMessages = [];
          } else {
            this.contactsData = [];
            this.activeIndex = -1;
            this.innerMessages = [];
          }
        })
        .catch(() => {
          this.contactsData = [];
          this.activeIndex = -1;
          this.innerMessages = [];
        })
        .finally(() => {
          this.contactsLoading = false;
        });
    },
    trySelectPresetConversation() {
      if (!this.visible) return;
      if (this.activeIndex !== -1) return;
      if (this.contactsLoading) return;
      const targetId = this.presetUserId;
      if (targetId === undefined || targetId === null || String(targetId).trim() === "") return;
      const targetType = this.presetUserType;
      const idx = (this.contactsData || []).findIndex((c) => {
        if (!c) return false;
        const contactId = c.id !== undefined && c.id !== null ? String(c.id) : "";
        const contactUserId = c.user_id !== undefined && c.user_id !== null ? String(c.user_id) : "";
        if (contactId !== String(targetId) && contactUserId !== String(targetId)) return false;
        if (targetType === undefined || targetType === null || String(targetType).trim() === "") return true;
        return String(c.user_type) === String(targetType);
      });
      if (idx < 0) return;
      const contact = this.contactsData[idx];
      this.activeIndex = idx;
      this.showPlaceholder = false;
      this.fetchMessageList(contact);
    },
    handleContactClick(index, contact) {
      this.activeIndex = index;
      this.showPlaceholder = false;
      this.fetchMessageList(contact);
    },
    getCurrentUserId() {
      const raw = localStorage.getItem("userInfo");
      if (!raw) return null;
      try {
        const userInfo = JSON.parse(raw);
        return userInfo && (userInfo.user_id || userInfo.id || userInfo.uid || userInfo.member_id);
      } catch (e) {
        return null;
      }
    },
    getConversationKey(contact) {
      if (!contact) return null;
      return (
        contact.conversation_id ||
        contact.conversationId ||
        contact.room_id ||
        contact.roomId ||
        contact.chat_id ||
        contact.chatId ||
        contact.id ||
        null
      );
    },
    fetchMessageList(contact) {
      if (!this.visible) return;
      if (!contact) {
        this.innerMessages = [];
        return;
      }
      this.messagesLoading = true;
      const conversationKey = this.getConversationKey(contact) || "default";
      this.$axios
        .post(`/v1/chat/messageList`, {
          user_id: contact.user_id,
          user_type: contact.user_type
        }, { useLog: true })
        .then((res) => {
          if (res && res.code == 0) {
            const myId = this.getCurrentUserId();
            const list = (res.data && res.data.list) || [];
            const normalized = list
              .map((item) => {
                if (!item) return null;
                const messageType = item.message_type !== undefined ? item.message_type : item.messageType;
                const fileUrl = item.file_url !== undefined ? item.file_url : item.fileUrl;
                const text = item.content || (String(messageType) === "2" && fileUrl ? "[图片]" : (String(messageType) === "3" && fileUrl ? "[视频]" : ""));
                const senderId = item.sender_id !== undefined ? item.sender_id : item.senderId;
                const side =
                  myId !== null &&
                  senderId !== undefined &&
                  senderId !== null &&
                  String(senderId) === String(myId)
                    ? "right"
                    : "left";
                return { side, text, message_type: messageType, file_url: fileUrl, raw: item };
              })
              .filter((m) => m && (m.text || m.file_url));
            this.innerMessages = normalized;
            this.rebuildDedupe(conversationKey, list);
            if (contact && contact.has_unread == 1) {
              contact.has_unread = 0;
            }
            this.$nextTick(() => {
              if (this.$refs.chatBody) {
                this.$refs.chatBody.scrollTop = this.$refs.chatBody.scrollHeight;
              }
            });
          } else {
            this.innerMessages = [];
            this.rebuildDedupe(conversationKey, []);
          }
        })
        .catch(() => {
          this.innerMessages = [];
          this.rebuildDedupe(conversationKey, []);
        })
        .finally(() => {
          this.messagesLoading = false;
        });
    },
    startPolling() {
      if (this.pollTimer) return;
      this.pollTimer = setInterval(() => {
        this.pollNewMessages();
      }, 2000);
      this.pollNewMessages();
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
      this.polling = false;
    },
    getMessageId(item) {
      if (!item) return null;
      return item.id !== undefined
        ? item.id
        : (item.message_id !== undefined ? item.message_id : item.messageId);
    },
    getMessageKey(item) {
      const id = this.getMessageId(item);
      if (id !== undefined && id !== null && String(id).trim() !== "") return "id:" + String(id);
      const senderId = item && (item.sender_id !== undefined ? item.sender_id : item.senderId);
      const createdAt = item && (item.created_at !== undefined ? item.created_at : item.createdAt);
      const content = item && (item.content || "");
      const messageType = item && (item.message_type !== undefined ? item.message_type : item.messageType);
      const fileUrl = item && (item.file_url !== undefined ? item.file_url : item.fileUrl);
      return "k:" + [senderId || "", createdAt || "", messageType || "", fileUrl || "", content].join("|");
    },
    rebuildDedupe(conversationKey, rawList) {
      const seen = new Set();
      let lastId = this.lastMessageIdByConversation[conversationKey] || 0;
      (rawList || []).forEach((item) => {
        const key = this.getMessageKey(item);
        if (key) seen.add(key);
        const id = this.getMessageId(item);
        const n = Number(id);
        if (id !== undefined && id !== null && String(id).trim() !== "" && !Number.isNaN(n)) {
          lastId = Math.max(lastId, n);
        }
      });
      this.seenMessageIdsByConversation[conversationKey] = seen;
      this.lastMessageIdByConversation[conversationKey] = lastId;
    },
    pollNewMessages() {
      if (!this.visible) return;
      if (this.polling) return;
      const contact = this.currentContact || {};
      if (!contact.user_id) return;

      const conversationKey = this.getConversationKey(contact) || "default";
      const lastId = this.lastMessageIdByConversation[conversationKey] || 0;
      const seen = this.seenMessageIdsByConversation[conversationKey] || new Set();

      this.polling = true;
      this.$axios
        .post(
          `/v1/chat/getNewMessages`,
          {
            conversation_id: contact.conversation_id,
            user_id: contact.user_id,
            user_type: contact.user_type,
            last_id: lastId,
          },
          { useLog: true }
        )
        .then((res) => {
          if (!res || res.code != 0) return;
          const list = (res.data && (res.data.list || res.data.data)) || [];
          if (!Array.isArray(list) || !list.length) return;

          const myId = this.getCurrentUserId();
          let hasAppend = false;
          list.forEach((item) => {
            if (!item) return;
            const key = this.getMessageKey(item);
            if (key && seen.has(key)) return;
            if (key) seen.add(key);
            const id = this.getMessageId(item);
            const n = Number(id);
            if (id !== undefined && id !== null && String(id).trim() !== "" && !Number.isNaN(n)) {
              this.lastMessageIdByConversation[conversationKey] = Math.max(
                this.lastMessageIdByConversation[conversationKey] || 0,
                n
              );
            }

            const messageType = item.message_type !== undefined ? item.message_type : item.messageType;
            const fileUrl = item.file_url !== undefined ? item.file_url : item.fileUrl;
            const text = item.content || (String(messageType) === "2" && fileUrl ? "[图片]" : (String(messageType) === "3" && fileUrl ? "[视频]" : ""));
            if (!text && !fileUrl) return;
            const senderId = item.sender_id !== undefined ? item.sender_id : item.senderId;
            const side =
              myId !== null &&
              senderId !== undefined &&
              senderId !== null &&
              String(senderId) === String(myId)
                ? "right"
                : "left";
            if (side !== "left") return;

            this.innerMessages.push({ side, text, message_type: messageType, file_url: fileUrl, raw: item });
            hasAppend = true;
          });

          this.seenMessageIdsByConversation[conversationKey] = seen;
          if (hasAppend) {
            this.$nextTick(() => {
              if (this.$refs.chatBody) {
                this.$refs.chatBody.scrollTop = this.$refs.chatBody.scrollHeight;
              }
            });
          }
        })
        .catch(() => {})
        .finally(() => {
          this.polling = false;
        });
    },
    triggerImageSelect() {
      if (this.sending) return;
      const input = this.$refs.imageInput;
      if (!input) return;
      input.value = "";
      input.click();
    },
    async handleImageSelected(e) {
      const file = e && e.target && e.target.files && e.target.files[0];
      if (!file) return;
      if (this.sending) return;

      this.sending = true;
      try {
        const fileName = file.name || "";
        const ext = fileName.includes(".") ? fileName.split(".").pop() : "";
        const safeExt = ext ? "." + ext : "";
        const filePath = `chat/images/${Date.now()}_${Math.random().toString(16).slice(2)}${safeExt}`;
        const result = await put(filePath, file);
        const url = result && result.url;
        if (!url) {
          if (this.$message) this.$message.error("图片上传失败");
          return;
        }
        await this.sendImageMessage(url);
      } catch (err) {
        if (this.$message) this.$message.error("图片上传失败");
      } finally {
        if (e && e.target) e.target.value = "";
        this.sending = false;
      }
    },
    sendImageMessage(fileUrl) {
      const contact = this.currentContact || {};
      return this.$axios
        .post(
          `/v1/chat/sendMessage`,
          {
            receiver_id: contact.user_id,
            receiver_type: contact.user_type,
            content: "",
            message_type: 2,
            file_url: fileUrl,
          },
          { useLog: true }
        )
        .then((res) => {
          if (res && res.code == 0) {
            this.innerMessages.push({
              side: "right",
              text: "[图片]",
              message_type: 2,
              file_url: fileUrl,
            });
            this.$nextTick(() => {
              if (this.$refs.chatBody) {
                this.$refs.chatBody.scrollTop = this.$refs.chatBody.scrollHeight;
              }
            });
          } else if (this.$message) {
            this.$message.error((res && res.msg) || "发送失败");
          }
        })
        .catch(() => {
          if (this.$message) this.$message.error("发送失败");
        });
    },
    triggerVideoSelect() {
      if (this.sending) return;
      const input = this.$refs.videoInput;
      if (!input) return;
      input.value = "";
      input.click();
    },
    async handleVideoSelected(e) {
      const file = e && e.target && e.target.files && e.target.files[0];
      if (!file) return;
      if (this.sending) return;

      this.sending = true;
      try {
        const fileName = file.name || "";
        const ext = fileName.includes(".") ? fileName.split(".").pop() : "";
        const safeExt = ext ? "." + ext : "";
        const filePath = `chat/videos/${Date.now()}_${Math.random().toString(16).slice(2)}${safeExt}`;
        const result = await put(filePath, file);
        const url = result && result.url;
        if (!url) {
          if (this.$message) this.$message.error("视频上传失败");
          return;
        }
        await this.sendVideoMessage(url);
      } catch (err) {
        if (this.$message) this.$message.error("视频上传失败");
      } finally {
        if (e && e.target) e.target.value = "";
        this.sending = false;
      }
    },
    sendVideoMessage(fileUrl) {
      const contact = this.currentContact || {};
      return this.$axios
        .post(
          `/v1/chat/sendMessage`,
          {
            receiver_id: contact.user_id,
            receiver_type: contact.user_type,
            content: "",
            message_type: 3,
            file_url: fileUrl,
          },
          { useLog: true }
        )
        .then((res) => {
          if (res && res.code == 0) {
            this.innerMessages.push({
              side: "right",
              text: "[视频]",
              message_type: 3,
              file_url: fileUrl,
            });
            this.$nextTick(() => {
              if (this.$refs.chatBody) {
                this.$refs.chatBody.scrollTop = this.$refs.chatBody.scrollHeight;
              }
            });
          } else if (this.$message) {
            this.$message.error((res && res.msg) || "发送失败");
          }
        })
        .catch(() => {
          if (this.$message) this.$message.error("发送失败");
        });
    },
    send() {
      const text = this.inputText && this.inputText.trim();
      if (!text) return;
      if (this.sending) return;
      this.sending = true;
      const contact = this.currentContact || {};
      this.$axios
        .post(`/v1/chat/sendMessage`, {
          receiver_id: contact.user_id,
          receiver_type: contact.user_type,
          content: text,
          message_type: 1,

        }, { useLog: true })
        .then((res) => {
          if (res && res.code == 0) {
            this.innerMessages.push({ side: "right", text });
            this.inputText = "";
            this.$nextTick(() => {
              if (this.$refs.chatBody) {
                this.$refs.chatBody.scrollTop = this.$refs.chatBody.scrollHeight;
              }
            });
          } else if (this.$message) {
            this.$message.error((res && res.msg) || "发送失败");
          }
        })
        .catch(() => {
          if (this.$message) this.$message.error("发送失败");
        })
        .finally(() => {
          this.sending = false;
        });
    },
  },
  beforeDestroy() {
    this.stopPolling();
  },
};
</script>
<style scoped lang="scss">
.consult_overlay {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.consult_container {
  width: 980px;
  height: 600px;
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  display: flex;
}
.close_btn {
  position: absolute;
  right: 18px;
  top: 12px;
  width: 32px;
  height: 32px;
  border-radius: 32px;
  background: #f5f5f5;
  color: #999;
  font-size: 22px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  z-index: 10;
}
.left_panel {
  width: 260px;
  background: #fff;
  display: flex;
  flex-direction: column;
}
.title_box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.title_icon {
  width: 55px;
  margin-right: 8px;
}
.title_text {
  font-size: 16px;
  color: #333;
}
.contact_list {
  flex: 1;
  overflow-y: auto;
}
.contact_list li {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  cursor: pointer;
  position: relative;
}
.contact_list li.active {
  background: #fdeeee;
}
.contact_list .avatar {
  width: 36px;
  height: 36px;
  border-radius: 100%;
  // background: #dcdcdc;
  margin-right: 12px;
 display: block;
  object-fit: cover;
}
.contact_list .name {
  font-size: 14px;
  color: #333;
}
.contact_list .unread_dot {
  position: absolute;
  left: 18px;
  top: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ee0903;
}
.right_panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #fff, #ffe9e3);
}
.placeholder_panel {
  flex: 1;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.placeholder_img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.chat_header {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 64px 0 20px;
}
.header_user {
  display: flex;
  align-items: center;
  color: #999;
  max-width: 100%;
}
.header_user .name {
  margin-right: 12px;
  max-width: 420px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.header_user .avatar {
  width: 32px;
  height: 32px;
  border-radius: 100%;
  background: #dcdcdc;
}
.chat_body {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}
.chat_hint {
  text-align: center;
  color: #999;
  font-size: 14px;
  padding: 16px 0;
}
.msg {
  margin-bottom: 12px;
}
.bubble {
  display: inline-block;
  max-width: 62%;
  padding: 10px 12px;
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.6;
  text-align: left;
}
.bubble.left {
  background: #ffffff;
  color: #666;
}
.bubble.right {
  background: #ee0903;
  color: #fff;
}
.bubble .msg_image {
  display: block;
  max-width: 260px;
  max-height: 260px;
  border-radius: 10px;
}
.bubble .msg_video {
  display: block;
  width: 260px;
  max-width: 100%;
  border-radius: 10px;
}
.msg.right {
  text-align: right;
}
.chat_footer {
  padding: 12px 20px 20px;
}
.tools {
  margin-bottom: 10px;
}
.tool_btn {
  display: inline-block;
  margin-right: 10px;
  background: #f3f3f3;
  color: #666;
  font-size: 12px;
  border-radius: 20px;
  padding: 6px 12px;
  cursor: pointer;
}
.tool_btn.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.file_input {
  display: none;
}
.input_row {
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 8px;
  padding: 6px 8px;
}
.text_input {
  flex: 1;
  height: 36px;
  border: none;
  outline: none;
  font-size: 14px;
  padding: 0 8px;
}
.send_btn {
  width: 70px;
  height: 32px;
  background: #ee0903;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
</style>
